angular.module('homebot.directives')

.directive('buyingPowerSection', ['Dictionary', function(Dictionary){
  return {
    restrict: 'AE',
    controllerAs: 'buyingPowerCtrl',
    bindToController: {
      agent: '=',
      home: '=',
      userId: '@',
    },
    scope: {},
    templateUrl: '/homes/templates/section-buying-power.html',
    controller: function(){
      let ctrl = this;
      let dictionary = new Dictionary();

      ctrl.lookup = function(prop){
        return dictionary[prop](ctrl.home);
      };
    },

    link: function($scope, el, attrs, ctrl){
    }
  }
}]);
